export default ({ id, address, additional, account: { planName, included = false }, hostingAddress, multiLanguage, otherLanguages }) => {
  const siteMultiLanguage = otherLanguages.length && {
    multiLanguage: {
      enabled: multiLanguage,
      languages: otherLanguages
    }
  }

  return {
    id,
    address,
    isAdditional: additional,
    isIncluded: included,
    plan: {
      name: planName,
      includedDomain: hostingAddress
    },
    ...siteMultiLanguage
  }
}
